<template>
    <div
        :class="[
            'guides-conversational-preview-empty-state',
            'placeholder-guide-element'
        ]"
        @click="action">
        <slot>
            <pendo-empty-state
                background-color="transparent"
                :title="title"
                :description="description">
                <template #icon>
                    <add-step-button />
                </template>
            </pendo-empty-state>
        </slot>
    </div>
</template>

<script>
import { PendoEmptyState } from '@pendo/components';
import AddStepButton from './add-step-button.vue';

export default {
    name: 'GuidesConversationalPreviewEmptyState',
    components: {
        PendoEmptyState,
        AddStepButton,
    },
    props: {
        title: {
            type: String,
            default: 'Add Step',
        },
        description: {
            type: String,
            default: 'Unable to save a guide with 0 steps',
        },
    },
    emits: ['primary-action'],
    methods: {
        action () {
            this.$emit('primary-action');
        },
    },
};
/* eslint-disable internal-rules/no-hardcoded-colors */
</script>

<style lang="less">
.guides-conversational-preview-empty-state{
    outline: 1px dashed var(--palette-blue-60);
    height: 100px;
    position: relative;

    &:hover {
        cursor: pointer;
    }

    &:hover,
    &:focus-within {
        background-color: rgba(11, 154, 211, 0.05);
        outline: 2px solid var(--palette-blue-60);
        outline-offset: -1px;
    }

    .pendo-empty-state__title,
    .pendo-empty-state__description {
        font-size: 14px;
        line-height: 20px;
        margin: 0;
    }

    .pendo-empty-state__description {
        color: var(--palette-gray-70);
    }

    .pendo-empty-state__inner {
        max-width: unset;
    }

    :focus {
        outline: none;
    }
}
</style>
